export default __webpack_public_path__ + "static/media/wisogisblue.730069ee.png";